// src/v3/currency/pound.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CurrencyPoundIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CurrencyPoundIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M17.249 18.74h-7.76c1-.809 1.61-1.738 1.85-2.777.25-1.09.03-2.13-.35-3.039h3.25c.41 0 .75-.34.75-.75 0-.409-.34-.749-.75-.749h-4.1c-.2-.28-.39-.53-.57-.73-.02-.04-.03-.08-.06-.11-.46-.589-.71-1.288-.71-2.038 0-1.819 1.49-3.298 3.32-3.298 1.06 0 2.03.48 2.66 1.33a.75.75 0 0 0 1.2-.9 4.85 4.85 0 0 0-3.86-1.929c-2.65 0-4.81 2.149-4.81 4.797 0 1.05.34 2.039.97 2.878h-1.43c-.41 0-.75.34-.75.75s.34.75.75.75h2.46c.44.779.78 1.748.57 2.708-.28 1.239-1.43 2.308-3.43 3.178a.73.73 0 0 0-.43.84c.08.35.38.599.73.599h10.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75v-.01Z"
  }
) });

export {
  CurrencyPoundIcon
};
